import { EColors } from '@rfc/rfc-components-library/types'

export enum ETemplate {
    RFID_CHIP = 'rfid_chip',
    PARCEL_LABEL = 'parcel_label',
    END_ROLL_LABEL = 'end_roll_label'
}

export const ETemplateValues = [
    ETemplate.RFID_CHIP,
    ETemplate.PARCEL_LABEL,
    ETemplate.END_ROLL_LABEL
]

export const ETemplateColors = {
    [ETemplate.RFID_CHIP]: EColors.PRIMARY,
    [ETemplate.PARCEL_LABEL]: EColors.SUCCESS,
    [ETemplate.END_ROLL_LABEL]: EColors.WARNING
}

export const ETemplateLabels = {
    [ETemplate.RFID_CHIP]: 'templates.types.rfid_chip',
    [ETemplate.PARCEL_LABEL]: 'templates.types.parcel_label',
    [ETemplate.END_ROLL_LABEL]: 'templates.types.end_roll_label'
}
